import { memo } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { SelectionItemsDropdown } from '~/components/v2/components/shared/selectionBar/SelectionItemsDropdown';
import { type SelectionActionBarItemCountState } from '~/components/v2/components/shared/selectionBar/selectionBarItemCountState';

export type SelectionActionBarItemCountProps = SelectionActionBarItemCountState & {
  summary: string;
};

export const SelectionActionBarItemCount = memo(
  ({ selectedItemCount, showSelectionDropdown, summary }: SelectionActionBarItemCountProps) => {
    if (!showSelectionDropdown) {
      return (
        <div
          className="flex items-center gap-1 ads:text-ads-gray-1 text-12 text-gray-1"
          data-testid="SELECTION_ACTION_BAR_ITEMS_SELECTED"
        >
          {summary}
        </div>
      );
    }

    return (
      <SelectionItemsDropdown
        selectedItemCount={selectedItemCount}
        trigger={
          <button
            className={cn(
              'group flex items-center gap-1 ads:text-ads-gray-1 text-12 text-gray-1',
              selectedItemCount > 1 && 'cursor-pointer',
            )}
            data-testid="SELECTION_ACTION_BAR_ITEMS_SELECTED"
            type="button"
          >
            {summary}
            {selectedItemCount > 1 && (
              <ChevronDownIcon
                size="sm"
                className="ads:text-ads-gray-1 text-gray-1 group-data-[state=open]:rotate-180"
              />
            )}
          </button>
        }
      />
    );
  },
);

SelectionActionBarItemCount.displayName = 'SelectionActionBarItemCount';
